/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Track_Labels_Main_Track_Aria_LabelInputs */

const en_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main Track`)
};

const fr_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste principale`)
};

const de_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptgleis`)
};

const it_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pista principale`)
};

const ru_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главная трасса`)
};

const es_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pista principal`)
};

const zh_cn2_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主轨道`)
};

const ja_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メイントラック`)
};

const hi_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य ट्रैक`)
};

const pt_pt2_track_labels_main_track_aria_label = /** @type {(inputs: Track_Labels_Main_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pista principal`)
};

/**
* | output |
* | --- |
* | "Main Track" |
*
* @param {Track_Labels_Main_Track_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_labels_main_track_aria_label = /** @type {((inputs?: Track_Labels_Main_Track_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Labels_Main_Track_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_track_labels_main_track_aria_label(inputs)
	if (locale === "de") return de_track_labels_main_track_aria_label(inputs)
	if (locale === "it") return it_track_labels_main_track_aria_label(inputs)
	if (locale === "ru") return ru_track_labels_main_track_aria_label(inputs)
	if (locale === "es") return es_track_labels_main_track_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_track_labels_main_track_aria_label(inputs)
	if (locale === "ja") return ja_track_labels_main_track_aria_label(inputs)
	if (locale === "hi") return hi_track_labels_main_track_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_track_labels_main_track_aria_label(inputs)
	return en_track_labels_main_track_aria_label(inputs)
});